import "./login.css";
import React, { useEffect, useState } from 'react';
import {useNavigate} from 'react-router-dom';
import { Row, Col, Form, Input, Typography, Checkbox, notification, Tag, Avatar, message } from 'antd';
import logo from '@src/assets/img/wc-logo-big.png';
import { useMutation } from "@apollo/client";
import { UserOutlined } from "@ant-design/icons";
import { CustomerLoginMutation } from "../../util/mutation/customerLogin/customerLogin.mutation";

export const Password=()=>{
    const navigate = useNavigate();
    useEffect(()=>{
        if(!sessionStorage.getItem('email')){
            navigate("/");
        }
    },[]);

    // fields
    const [showPass, setShowPass] = useState(false);

    const [customerPin, setCustomerPin] = useState({value:'',error:''});
    const handelCustomerPin = (e)=>{
        const regex = /[a-zA-Z]/;
        if(e && !regex.test(e)){
            setCustomerPin({value: e?.toString(), error:''});
        }else{
            setCustomerPin({value: '', error:'PIN is invalid'});
        }
    };

    const [messageApi, contextHolder] = message.useMessage();


    const [customerAuth, {loading: customerAuthLoading}] = useMutation(CustomerLoginMutation);

    const handelAuth = async()=>{
        try{
            
            const customerAuthResponse = await customerAuth({
                variables:{
                    input:{
                        email: sessionStorage.getItem('email'),
                        pin: customerPin?.value,
                    }
                }
            });

            const {customerDetail, token} = customerAuthResponse?.data?.verifyCustomerPin?.response;
            localStorage.setItem('authToken', token);
            localStorage.setItem('customerDetail', JSON.stringify(customerDetail));
            messageApi.success("Login successfully");
            navigate("/customer")

        }catch(err){
            messageApi.error("Email address or PIN may be invalid");
        }
    };


    return(
        <div className="login-parent-window">
            {contextHolder}
            <div className='login-box'>
                <div className='login-form-container'>
                    <img src={logo} alt="" width={75} height={65}/>
                    
                    <Typography.Title level={3} className='text-center login-title' >
                        Welcome     {/* {emailVerificationDetail?.name} */}
                    </Typography.Title>
                        
                    <div className="text">
                        <Tag style={{color:'black', fontWeight:'500', padding:'2px 10px'}}>
                            <Avatar size={20}> <UserOutlined/> </Avatar>    {sessionStorage.getItem('email')}
                        </Tag>
                    </div>

                    <Form.Item style={{marginTop: '45px'}}>
                        <Input autoFocus placeholder='PIN' className='generic-input-control' type={showPass? "text" : "password"}  onChange={(e)=>{handelCustomerPin(e.target.value)}}/>
                        <div className="ant-form-text helper-text" style={{textAlign: 'left', marginTop: '5px', height:'15px'}}>{customerPin?.error && customerPin?.error}</div>

                    
                        <Form.Item className='validationCheckboxGroup' style={{textAlign:'left'}}>
                        
                            <Checkbox onChange={()=>setShowPass(!showPass)}>
                                Show PIN
                            </Checkbox>
                        </Form.Item>
                    </Form.Item>


                    
                    <div  className="login-btnGrp" >
                        
                        <div className="forgetPassword" style={{marginTop:'5px'}} >Forget PIN ?</div>
                       
            
                        <button disabled={customerAuthLoading} onClick={handelAuth} className={customerAuthLoading? " disabled-btn drawer-filled-btn " :"drawer-filled-btn"}>Next</button>
                    
                    </div>
                </div>
                

            </div>


        </div>
    )
}